export const PAYMENT_METHODS = {
  APPLE_PAY: "ecommpay-apple-pay",
};